module.exports = __webpack_public_path__ + "static/1-eb5236777202b7bfb404fe559f33531e.png";